import { MSL_API_URL } from 'environment';
import { uploadFileAPI } from './utility';

export async function getPremiumCustomersAPI(token, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/user-premium${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function resendInvitationPremium(token) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'POST', headers: myHeaders };

  return fetch(`${MSL_API_URL}/admin/user-premium/resend-invitation`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getCustomersAPI(token, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getCustomerDetailAPI(token, id) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function addCustomerAPI(token, customerForm) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...customerForm });

  const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function addPremiumCustomerAPI(token, product_type_id, user_ids) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({
    product_type_id,
    user_ids,
  });

  const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/user-premium`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateCustomerAPI(token, id, customerForm) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...customerForm });

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function verificationIdentityCustomerAPI(token, id) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'PUT', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/verifikasi-ktp/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function downgradePremiumBidder(token, body) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify(body);

  const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/user-premium/refund`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateCustomerFileAPI(token, id, file) {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const formData = new FormData();
  formData.append('identity_file', file);
  const requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: formData,
    redirect: 'follow',
  };

  return fetch(`${MSL_API_URL}/admin/pelanggan/file/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function removeCustomerAPI(token, id) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'DELETE', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getFormOptionCustomerAPI(token) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/opsi/form`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function addSellerFeeAPI(token, body) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify(body);

  const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/biaya-seller`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateSellerFeeAPI(token, id, body) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify(body);

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/biaya-seller/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateMOUFileAPI(token, id, mou_file) {
  var myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  var formdata = new FormData();
  formdata.append('mou_file', mou_file);

  var requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: formdata,
    redirect: 'follow',
  };

  return fetch(`${MSL_API_URL}/admin/pelanggan/biaya-seller/file/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateBuyerFeeAPI(token, id, body) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify(body);

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/biaya-pembeli/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function acceptOrRejectManualNIPLAPI(token, userID, body) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify(body);

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(
    `${MSL_API_URL}/admin/pelanggan/riwayat-nipl/${userID}/tab-list/action`,
    requestOptions,
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getCustomerInventoriesAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/unit/${id}${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function addCustomerInventoryAPI(token, inventoryForm) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...inventoryForm });

  const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/unit`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateCustomerInventoryAPI(token, id, inventoryForm) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...inventoryForm });

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/unit/${id}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function removeCustomerInventoryAPI(token, id) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({
    ids: [id],
  });

  const requestOptions = { method: 'DELETE', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/unit`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getNiplAuctionAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/riwayat-nipl/${id}${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getNiplAuctionManualAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/riwayat-nipl/${id}/tab-list${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getHistoryAuctionAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/riwayat-lelang/${id}${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function getHistoryPremiumAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(
    `${MSL_API_URL}/admin/pelanggan/riwayat-premium/${id}${query}&sort=paid_at-`,
    requestOptions,
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function confirmReturnNiplAPI(token, customerId, niplId, form) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...form });

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(
    `${MSL_API_URL}/admin/pelanggan/riwayat-nipl/${customerId}/konfirmasi-return/${niplId}`,
    requestOptions,
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function confirmReturnPremiumAPI(token, premiumID, form) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...form });

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(
    `${MSL_API_URL}/admin/pelanggan/riwayat-premium/konfirmasi-return/${premiumID}`,
    requestOptions,
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export const uploadFakturPajak = async (token, file, customerId) => {
  const directory = 'faktur-pajak';
  try {
    // Upload file
    const uploadResult = await uploadFileAPI(token, file, directory);

    if (uploadResult?.meta?.http_status !== 200) {
      return {
        success: false,
        message: uploadResult?.message || 'Gagal upload faktur pajak',
        meta: uploadResult?.meta,
      };
    }

    // Update faktur path
    const updateResult = await updateFakturPajak(token, customerId, uploadResult?.data?.path);

    if (updateResult?.meta?.http_status !== 200) {
      return {
        success: false,
        message: updateResult?.message || 'Gagal update faktur pajak',
        meta: updateResult?.meta,
      };
    }

    return {
      success: true,
      message: 'Berhasil upload faktur pajak',
      data: updateResult?.data,
      meta: updateResult?.meta,
    };
  } catch (error) {
    console.error('Error in uploadFakturPajak:', error);
    return {
      success: false,
      message: error.message || 'Gagal upload faktur pajak',
      meta: { http_status: 500 },
    };
  }
};

export const updateFakturPajak = async (token, customerId, filepath) => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const body = {
    faktur_filepath: filepath,
  };

  const requestOptions = {
    method: 'PUT',
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: 'follow',
  };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${customerId}/update-faktur`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
};

export async function getRequestRefundAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/riwayat-nipl/${id}/export${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function updateCustomerADMFAPI(token, id, customerForm) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...customerForm });

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}/adira`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

// ====== CUSTOMER SINGLE BIDER =====

export async function getCustomerBidderAPI(token, id, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}/customer-bidders${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

// Gabungan bidder dari beberapa seller sekaligus (deduplicated oleh BE).
// query wajib membawa customer_ids berformat CSV, contoh: ?customer_ids=10,20&page=1&limit=10
export async function getCustomerBiddersBySellersAPI(token, query) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/customer-bidders${query}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function addCustomerBidderAPI(token, inventoryForm, id) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...inventoryForm });

  const requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}/customer-bidders`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function editCustomerBidderAPI(token, inventoryForm, id, bidderId) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const raw = JSON.stringify({ ...inventoryForm });

  const requestOptions = { method: 'PUT', headers: myHeaders, body: raw, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}/customer-bidders/${bidderId}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export async function removeCustomerBidderAPI(token, id, bidderId) {
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = { method: 'DELETE', headers: myHeaders, redirect: 'follow' };

  return fetch(`${MSL_API_URL}/admin/pelanggan/${id}/customer-bidders/${bidderId}`, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}
